import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';

import { useAppDispatch, useAppSelector } from '../../services/hooks';
import { setModalShow } from '../../stores/user/userSlice';
import SpinnerContainer from '../Spinner/SpinnerContainer';
import { useTranslation } from 'react-i18next';
import LoginForm from '../LoginForm';

export default function HeaderAccountModalGuest() {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const showAccountModal = useAppSelector((state) => state.user.auth.modalShow);
    const loading = useAppSelector((state) => state.user.auth.loading);

    function onHide() {
        dispatch(setModalShow(false))
    }

    return (
        <Modal show={showAccountModal} onHide={onHide} id="accountNavModal" aria-labelledby="NavModal" dialogClassName='modalDialogBasket modal-sm breakWord'>
            <SpinnerContainer enabled={loading}>
                <Modal.Header>
                    <button type="button" onClick={onHide} className="btn-close" aria-label="Close"></button>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid>
                        <LoginForm />
                    </Container>
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    {t('header.modal.account.noaccount')}
                    <a href="/register" className="btn btn-sm btn-outline-primary">{t('header.modal.account.register')}</a>
                </Modal.Footer>
            </SpinnerContainer>
        </Modal >
    )
}